.container {
  display: grid;
  gap: 8px;
}

.zipContainer {
  display: flex;
  gap: 8px;
}

.zipField {
  width: 140px;

  input {
    width: 100%;
  }
}

.overseasNote {
  font-size: var(--font-size-xs);
}
